import { HTMLAttributes } from 'react'
import styles from './loader.module.css'
import clsx from 'clsx'

export const Loader = ({className, ...props}: HTMLAttributes<HTMLSpanElement>) => {

  return (
    <span className={clsx(styles.wrapper, className)} {...props}>
      <span className={styles.loader}></span>
    </span>
  )
}